import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { validatePermission } from "../../../../utils/permissionUtils";
import { usePermissions } from "../../../../context/permissionContext";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/datatable.scss";

const OfferorList = () => {
  const [query, setQuery] = useState("");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("accessToken");
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
  const { permissions, permissionsMapping } = usePermissions();

  const hasEditPermission = validatePermission(
    "FAQ's - Offeror:Edit",
    permissions,
    permissionsMapping
  );
  const hasDeletePermission = validatePermission(
    "FAQ's - Offeror:Delete",
    permissions,
    permissionsMapping
  );

  const search = (data) => {
    return data?.filter(
      (item) =>
        item?.page_title?.toLowerCase()?.includes(query) ||
        item?.page_content?.toLowerCase()?.includes(query) ||
        item?.slug?.toLowerCase()?.includes(query)
    );
  };

  const deleteFunction = (id) => {
    // const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "delete",
          url: process.env.REACT_APP_API + "delete-faq-que-ans",
          headers: {
            "x-access-token": token,
          },
          data: {
            id: id,
          },
        };
        axios(config)
          .then(function (res) {
            if (res.status == 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              fetchAccreditedData();
              setLoading(false);
            }
          })
          .catch(function (error) {
            setLoading(false);
            console.log(error);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "Your data is safe", "error");
      }
    });
  };

  const fetchAccreditedData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    var config = {
      method: "post",
      url: process.env.REACT_APP_API + "get-faq-que-ans",
      headers: {
        "x-access-token": token,
      },
      data: {
        page: pageState.page,
        limit: pageState.pageSize,
        type: "offeror",
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchAccreditedData();
  }, [pageState.page, pageState.pageSize, query]);

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Link
              to={`/offeror-faq/${params.row.id} `}
              style={{ textDecoration: "none" }}
            >
              <div className="viewButton">
                <RemoveRedEyeOutlinedIcon />
              </div>
            </Link>
            {hasEditPermission && (
              <Link
                to={`/offeror-faq/edit/${params.row.id} `}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">
                  <EditOutlinedIcon />
                </div>
              </Link>
            )}
            {hasDeletePermission && (
              <div
                className="deleteButton"
                onClick={() => deleteFunction(params.row.id)}
              >
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "en_question",
      headerName: "FAQ Tittle",
      width: 240,
    },

    {
      // field: "page_title_en",
      headerName: "FAQ Answer",
      width: 500,
      renderCell: (params) => {
        return <div className="cellAction">{params.row.en_answer}</div>;
      },
    },
    {
      field: "display_order",
      headerName: "Order",
      width: 240,
    },
  ];

  return (
    <div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setQuery(e.target.value)}
          />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Offeror FAQs</h5>
        {hasEditPermission && (
          <Link to="/offeror-faq/add" className="link">
            Add New
          </Link>
        )}
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(actionColumn)}
      />
    </div>
  );
};

export default OfferorList;
